import {CommsTemplateDTO} from "./commsTemplateDTO";

export interface CommsTemplatePreviewRequestDTO {
  commsTemplate: CommsTemplateDTO;
  previewId: number;
  previewRecipient: string;
}
